import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import isEqual from 'lodash/isEqual';
import throttle from 'lodash/throttle';
import RaisedButton from 'material-ui/RaisedButton';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import {
  fetchSlateViewsList,
  setCurrentSlateView,
  fetchSlates,
  clearSlates,
  fetchSlateView,
  fetchCurrentSlate,
} from 'store/actions/slateViews';
import { openSlateInPane, updateSlatePane } from 'store/actions/slatePane';
import { createJob } from 'store/actions/jobs';
import {api, entityNames, notificationTypes, route} from 'config/constants';
import BasicDialog from 'components/Dialogs/BasicDialog';
import SlateViewsDropdown from '../SlateViews/SlateViewsDropdown';
import CreateViewDialog from 'components/SlateViews/CreateViewDialog';
import SlateTable from 'containers/SlateTable/SlateTable';
import EmptyState from 'components/Shared/EmptyState/EmptyState';
import MapView from 'containers/Map/MapView';
import Preloader from '../Preloader/Preloader';
import { slateViewsTypes, fieldsTypes } from 'config/constants';
import { listViewTypes, slateTypes } from 'config/constants';
import SlateViewChip from 'components/Shared/SlateViewChip';
import ListEmptyState from 'components/SlateViews/ListEmptyState';
import { presetNames } from 'config/constants';
import {checkVersion, handleVersion} from 'helpers/versionsHelper';
import './style.css';
import theme from './theme';
import palette from '../../theme/palette';
import { showNotification } from 'store/actions/notification';
import i18next from "i18next";
import {getAccountByUUID, isLoggedOut} from "../../helpers/accountHelper";
import {getAccount, setCurrentAccountByUUID} from "../../store/actions/account";
import axios from "axios";
import {options} from "../../helpers/cookieHelper";
import {CopyTableButton} from "./CopyTable";
import ShareModal from "./ShareModal";
import {Tooltip} from "@material-ui/core";

// Material Symbol component for modern icons
const MaterialSymbol = ({ name, style = {}, className = '' }) => (
  <span
    className={`material-symbols-outlined ${className}`}
    style={{ fontSize: 20, lineHeight: 1, ...style }}
  >
    {name}
  </span>
);

const ARROW_UP = 'ArrowUp';
const ARROW_DOWN = 'ArrowDown';
const THROTTLE_TIME = 250;

class SlateView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpenSlateViewsSelector: false,
      slateViewsSelectorAnchorEl: null,
      isOpenSettingsPopover: false,
      isOpenExportDialog: false,
      isOpenShareDialog: false,
      isOpenCreateViewDialog: false,
      isViewListFakeLoading: false,
      autoRefreshTableTimer: null,
    };

    this.active = null;
    this.isListView = false;
    this.isMapView = false;
    this.isMapSlatesFetched = false;
    this.isMapSlatesFetchFailed = false;
    this._isMounted = false;

    this.delayedSlatePaneOpen = throttle(this.openSlatePane, THROTTLE_TIME);
  }

  static defaultProps = {
    filters: [],
  };

  UNSAFE_componentWillMount() {
    checkVersion();
  }

  setAutoRefreshTimer() {
    this.setState({
      autoRefreshTableTimer: setInterval(this.handleRefreshClick, 30000),
    });
  }

  removeAutoRefreshTimer() {
    clearInterval(this.state.autoRefreshTableTimer);
    this.setState({
      autoRefreshTableTimer: null,
    });
  }

  componentDidMount() {
    this._isMounted = true;

    const {
      currentSlateView,
      fetchSlateViewsList,
      setCurrentSlateView,
      slateViewType,
      currentUser,
      getAccount,
      currentAccount,
      listViews,
      mapViews,
      history,
      showNotification,
      t,
      setCurrentAccountByUUID,
      match,
    } = this.props;

    const { views: slateViewUuid, accounts: accountUuid } = this.props.match.params;

    // if link incorrect - redirect to login
    if((!slateViewUuid || !accountUuid) && !!isLoggedOut(currentUser)) {
      history.push({
        pathname: `${route.START}`,
      });
      showNotification(
        notificationTypes.WARNING,
        t('notifications:linkIsNotCorrect'),
      );
    }

    const isAccountUuidFromUrlFake = accountUuid === ':accounts';
    const isAccountUuidFromUrlMatchWithCurrent = currentAccount && (currentAccount.uuid !== accountUuid);

    // if no AccountUuid in url - we should add it
    if(isAccountUuidFromUrlFake && currentAccount) {
      this.addAccountUuidToURL(currentAccount.uuid);
      if(!isLoggedOut(currentUser)) {
        fetchSlateViewsList(currentAccount.uuid);
      }
      return;
    } else if (isAccountUuidFromUrlMatchWithCurrent && !isAccountUuidFromUrlFake) {
      this.addAccountUuidToURL(accountUuid);
      setCurrentAccountByUUID(accountUuid);
      return;
    } if (isAccountUuidFromUrlFake) {
      return;
    }

    // set View type if user login
    if(slateViewType) {
      this.checkSlateViewType(slateViewType);
    }

    // get account info (and SlateViewsList if user login)
    if (accountUuid) {
      getAccount(accountUuid);

      if(!isLoggedOut(currentUser)) {
        fetchSlateViewsList(accountUuid);
      }
    }


    // set CurrentSlateView and fetch slates
    if (slateViewUuid) {
      const isViewListEmpty = (!listViews || listViews.length === 0) && (!mapViews || mapViews.length === 0);

        if (
          isViewListEmpty &&
          !this.state.isViewListFakeLoading
        ) {
          this.handleFetchView(accountUuid, slateViewUuid).then(() => {});
        }

        setCurrentSlateView(slateViewUuid);
        this.handleFetchSlates(
        {
          ...this.props,
          currentSlateView: {uuid: slateViewUuid},
          _accountUUID: accountUuid,
        }, true, true);
    } else if (currentSlateView && slateViewType && accountUuid === currentAccount.uuid) {
      this.handleFetchSlates(this.props, true);
      // this.addSlateViewUUIDInURL(currentSlateView.uuid, accountUuid);
    }

    document.addEventListener('scroll', this._handleScrollEvent, true);

    const { accounts: accountUuidFromUrl } = match.params;

    if(!currentAccount && !currentSlateView) {
      setCurrentAccountByUUID(accountUuidFromUrl);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      slateViewType,
      currentSlateView,
      currentUser,
      listViews,
      mapViews,
      fetchSlateViewsList,
      currentAccount,
      slateViewsListGetEntity,
    } = this.props;
    const { currentAccount: nextPropsCurrentAccount, currentUser: nextPropsCurrentUser } = nextProps;
    const { views: slateViewUuidFromUrl, accounts: accountUuidFromUrl } = nextProps.match.params;
    const isAccountUuidFromUrlFake = accountUuidFromUrl === ':accounts';

    if(
      !slateViewUuidFromUrl &&
      currentAccount &&
      currentAccount.uuid &&
      !slateViewsListGetEntity &&
      !isLoggedOut(currentUser)
    ) {
      fetchSlateViewsList(currentAccount.uuid);
      return;
    }

    this.checkSlateViewType(nextProps.slateViewType);

    if(isAccountUuidFromUrlFake && nextPropsCurrentAccount) {
      this.addAccountUuidToURL(nextPropsCurrentAccount.uuid);
      fetchSlateViewsList(nextPropsCurrentAccount.uuid);
      return;
    } else if (
      nextPropsCurrentAccount &&
      (nextPropsCurrentAccount.uuid !== accountUuidFromUrl) &&
      !isAccountUuidFromUrlFake
    ) {
      return;
    } if (isAccountUuidFromUrlFake) {
      return;
    }
    if((nextPropsCurrentAccount && currentAccount &&
      (nextPropsCurrentAccount.uuid !== currentAccount.uuid))
      || (isLoggedOut(currentUser) && !isLoggedOut(nextPropsCurrentUser))
    ) {
      fetchSlateViewsList(accountUuidFromUrl);
      return;
    }

    if (!slateViewUuidFromUrl && currentSlateView && nextPropsCurrentAccount &&
      (nextPropsCurrentAccount.uuid === accountUuidFromUrl)) {
      this.addSlateViewUUIDInURL(currentSlateView.uuid, accountUuidFromUrl);
      return;
    }

    if (nextProps.currentSlateView && nextPropsCurrentAccount) {
      const viewChanged = (!slateViewType && nextProps.slateViewType) ||
        ((currentSlateView && currentSlateView.uuid) !== nextProps.currentSlateView.uuid);

      if (viewChanged)
      {
        if (
          (!listViews || listViews.length === 0) &&
          (!mapViews || mapViews.length === 0) &&
          isLoggedOut(currentUser) &&
          !this.state.isViewListFakeLoading
        ) {
          this.handleFetchView(nextPropsCurrentAccount.uuid, nextProps.currentSlateView.uuid).then(() => {});
        }

        this.handleFetchSlates(
          nextProps,
          true,
          currentSlateView && currentSlateView.uuid !== nextProps.currentSlateView.uuid,
          );
      } else {
        // If view hasn't changed but slates are undefined and we're not fetching, refetch
        const needsRefetch = !nextProps.slates &&
          nextProps.slatesGetEntity &&
          !nextProps.slatesGetEntity.isFetching;

        if (needsRefetch) {
          this.handleFetchSlates(nextProps, true, true);
        }
      }

      // fetch all slates for map view
      if (this.isMapView) {
        // A fetch that ends without producing slates (request failed) must
        // release the preloader, which is a full-page overlay that would
        // otherwise keep covering the header controls
        const wasFetchingSlates = this.props.slatesGetEntity &&
          this.props.slatesGetEntity.isFetching;
        const isFetchingSlates = nextProps.slatesGetEntity &&
          nextProps.slatesGetEntity.isFetching;
        if (isFetchingSlates) {
          this.isMapSlatesFetchFailed = false;
        } else if (wasFetchingSlates && !nextProps.slates) {
          this.isMapSlatesFetchFailed = true;
        }

        if (!isEqual(nextProps.slates, this.props.slates)) {
          if (nextProps.slatesToken) {
            this.handleFetchSlates(nextProps);
          } else {
            this.isMapSlatesFetched = true;
          }
        } else if (
          isEqual(nextProps.slates, this.props.slates)
          && !nextProps.slatesToken
          && this.props.slates
        ){
          this.isMapSlatesFetched = true;
        }

        if (!nextProps.slates) {
          this.isMapSlatesFetched = false;
        }
      }

      if (!nextProps.slates) {
        this.isMapSlatesFetched = false;
      }

      // Sync the slate pane nav list when slates change
      if (nextProps.slates && nextProps.slates !== this.props.slates && nextProps.slateInSlatePaneUUID) {
        var navList = nextProps.slates.map(function(s) { return s.slateUUID; });
        if (!isEqual(navList, nextProps.slatePaneNavList)) {
          this.props.updateSlatePane({ slatePaneNavList: navList });
          try {
            sessionStorage.setItem('slatePaneNavList', JSON.stringify(navList));
          } catch (e) { /* ignore */ }
        }
      }
    }

    const isSlatesAlreadyGot = nextProps.slatesGetEntity &&
      nextProps.slatesGetEntity.isFetching;

    if (!isSlatesAlreadyGot) {
      if (!this.props.autoRefresh && nextProps.autoRefresh && this.state.autoRefreshTableTimer === null) {
        this.setAutoRefreshTimer();
      } else if (this.props.autoRefresh && !nextProps.autoRefresh && this.state.autoRefreshTableTimer !== null) {
        this.removeAutoRefreshTimer();
      }
    }
  }

  shouldComponentUpdate = (nextProps, nextState) =>
    !(isEqual(nextProps, this.props) && isEqual(nextState, this.state));

  componentWillUnmount = () => {
    this._isMounted = false;
    this.props.clearSlates();
    document.removeEventListener('scroll', this._handleScrollEvent, true);
    this.removeAutoRefreshTimer();
  };

  render() {
    const {
      isOpenSlateViewsSelector,
      slateViewsSelectorAnchorEl,
      isOpenExportDialog,
      isOpenShareDialog,
      isOpenCreateViewDialog,
    } = this.state;

    const {
      currentSlateView,
      slates,
      rowCount,
      listViews,
      mapViews,
      filters,
      t,
      slateInSlatePaneUUID,
      currentUser,
      accountsList,
      currentAccount,
      slatePaneNavList,
    } = this.props;

    const isSlateViewExist = this.checkSlateViewExist();

    const currentSlateIndex = (slatePaneNavList || []).indexOf(slateInSlatePaneUUID);
    const prevSlateIndex = currentSlateIndex - 1;
    const nextSlateIndex = currentSlateIndex + 1;
    const isPrevExist = currentSlateIndex >= 0 && prevSlateIndex >= 0;
    const isNextExist =
      slatePaneNavList && currentSlateIndex >= 0 && nextSlateIndex < slatePaneNavList.length;

    const rowHeightPreset =
      currentSlateView &&
      currentSlateView.columns &&
      currentSlateView.columns.find(
        (column) => column.type === fieldsTypes.PHOTO,
      )
        ? presetNames.mediumIfPhoto
        : null;

    const shareUrl = window.location.href;
    const { views: slateViewUuidFromUrl, accounts: accountUuidFromUrl } = this.props.match.params;

    let existingAccountUUID = false;

    if(currentAccount && accountsList) {
      existingAccountUUID = !!getAccountByUUID(currentAccount.uuid, accountsList);
    }

    return (
      <div
        className="inner-page slate-view"
        tabIndex="0"
        onKeyDown={(e) =>
          this.handleKeyDown(
            e,
            slatePaneNavList,
            isPrevExist,
            isNextExist,
            prevSlateIndex,
            nextSlateIndex,
          )
        }
      >
        {isSlateViewExist ? (
          <>
            {this.showPreloader()}
            {(this.isListView || this.isMapView) && (
              <div className="inner-page-header">
                <div className={classnames('inner-page-title', { 'inner-page-title-compact': isLoggedOut(currentUser) || !existingAccountUUID })}>
                      {
                        isLoggedOut(currentUser) || !existingAccountUUID ?
                          <h1>{currentSlateView.name}</h1> :
                          <RaisedButton
                            label={currentSlateView.name}
                            labelPosition="before"
                            onClick={this.handleSlateViewsSelectorOpen}
                            backgroundColor={palette.sidebarBg}
                            icon={
                              <i
                                className={`material-symbols-outlined slate-view-selector-chevron${isOpenSlateViewsSelector ? ' slate-view-selector-chevron-open' : ''}`}
                                style={theme.selectorButtonIcon}
                              >
                                keyboard_arrow_down
                              </i>
                            }
                            style={theme.selectorButton}
                            buttonStyle={
                              this.isListView
                                ? theme.selectorButtonVariantList
                                : theme.selectorButtonVariantMap
                            }
                            labelStyle={{...theme.selectorButtonLabel, ...theme.labelForSelector}}
                          />
                      }
                      {currentSlateView.listViewType && (
                        <SlateViewChip
                          type={currentSlateView.listViewType}
                          count={currentSlateView.count}
                          className="slate-view-header-badge"
                        />
                      )}

                      {filters.length > 0 && slates && (
                        <div className="slate-view-counter-filtered">
                          <span className="slate-view-counter-filtered-icon">
                            <i className="material-symbols-outlined">filter_alt</i>
                          </span>
                          <span className="slate-view-counter-filtered-divider" />
                          <span className="slate-view-counter-filtered-count">
                            {rowCount && rowCount.toLocaleString()}
                          </span>
                        </div>
                      )}
                    </div>

                <div className="slate-view-actions">
                  <Tooltip title={t('tooltips:autoRefresh')} placement={'top'}>
                    <div className={classnames('auto-refresh-toggle-wrapper slate-view-actions-refresh', {
                      'auto-refresh-toggle-active': this.state.autoRefreshTableTimer !== null,
                      'auto-refresh-toggle-animating': this.state.autoRefreshTableTimer !== null && !this.props.slatesGetEntity.isFetching,
                    })}>
                      <div className="auto-refresh-toggle-progress" />
                      <RaisedButton
                        icon={<MaterialSymbol name="rotate_auto" style={{
                          ...theme.slateViewActionIconStyle,
                          fontSize: 22,
                        }} />}
                        style={theme.slateViewActionStyle}
                        backgroundColor={undefined}
                        onClick={() => {
                          if (this.state.autoRefreshTableTimer === null) {
                            if (!isLoggedOut(currentUser)) {
                              this.props.showNotification(
                                notificationTypes.SUCCESS,
                                t('slateView:autoRefresh'),
                              );
                            }
                            this.setAutoRefreshTimer();
                          } else {
                            this.removeAutoRefreshTimer();
                          }
                        }}
                      />
                    </div>
                  </Tooltip>
                  <Tooltip title={t('tooltips:refreshView')} placement={'top'}>
                    <RaisedButton
                      icon={<MaterialSymbol name="rotate_auto" className="slate-view-refresh-icon" style={{...theme.slateViewActionIconStyle, fontSize: 22}} />}
                      style={theme.slateViewActionStyle}
                      onClick={this.handleRefreshClick}
                    />
                  </Tooltip>

                  <div className="slate-view-actions-divider" />

                  <Tooltip title={t('tooltips:sharableViewLink')} placement={'top'}>
                    <RaisedButton
                      icon={<MaterialSymbol name="share" style={theme.slateViewActionIconStyle} />}
                      style={theme.slateViewActionStyle}
                      onClick={this.handleShareDialogOpen}
                    />
                  </Tooltip>

                  {!isLoggedOut(currentUser) && this.isListView && (
                    <Tooltip title={t('tooltips:export')} placement={'top'}>
                      <RaisedButton
                        icon={<MaterialSymbol name="download" style={{...theme.slateViewActionIconStyle, fontSize: 22}} />}
                        style={theme.slateViewActionStyle}
                          onClick={this.handleExportDialogOpen}
                      />
                    </Tooltip>
                  )}
                  {!this.isMapView && (
                    <CopyTableButton
                      slates={slates || []}
                      currentSlateView={currentSlateView}
                      showNotification={this.props.showNotification}
                      rowCount={rowCount}
                      fetchMoreSlates={() => this.handleFetchSlates(this.props)}
                      disabled={!slates || slates.length === 0}
                    />
                  )}

                  {!isLoggedOut(currentUser) && (
                    <>
                      <div className="slate-view-actions-divider" />
                      <Tooltip title={t('tooltips:viewConfiguration')} placement={'top'}>
                        <Link to={`/settings/accounts/${accountUuidFromUrl}/views/${slateViewUuidFromUrl}/`}>
                          <RaisedButton
                            icon={<MaterialSymbol name="settings" style={theme.slateViewActionIconStyle} />}
                            style={theme.slateViewActionStyle}
                                />
                        </Link>
                      </Tooltip>
                    </>
                  )}
                </div>
              </div>
            )}

            <div className="slate-view-container">
              <div className="slate-view-inner">
                <div className="slate-view-data">
                  {this.isListView && (
                    <>
                      <SlateTable
                        onRowClickParentHandler={(e, uuid) =>
                          this.openSlatePane(uuid)
                        }
                        slateViewUUID={currentSlateView.uuid}
                        slates={slates}
                        columns={currentSlateView.columns}
                        rowCount={rowCount}
                        isExpandable={false}
                        rowHeightPreset={rowHeightPreset}
                      />
                      {slates && slates.length === 0 && (
                        <ListEmptyState t={t} />
                      )}
                    </>
                  )}

                  {this.isMapView && this.isMapSlatesFetched && (
                    <MapView
                      slates={slates}
                      onMarkerClick={(e, uuid) => this.openSlatePane(uuid)}
                    />
                  )}
                </div>

              </div>
            </div>

            <BasicDialog
              title={t('settings:export')}
              open={isOpenExportDialog}
              onClose={this.handleExportDialogClose}
              actions={[
                <RaisedButton
                  key="cancel"
                  label={t('btn:cancel')}
                  className="slate-view-settings-dialog-btn"
                  onClick={this.handleExportDialogClose}
                />,
                <RaisedButton
                  key="export"
                  disabled={!currentSlateView}
                  label={t('settings:export')}
                  primary={true}
                  onClick={this.handleExportSlateView}
                />,
              ]}
            >
              <div className="slate-view-settings-dialog">
                {t('settings:configureAnExportJob')}
              </div>
            </BasicDialog>

            <ShareModal
              open={isOpenShareDialog}
              onClose={this.handleShareDialogClose}
              shareUrl={shareUrl}
            />

            {listViews && mapViews && (
              <SlateViewsDropdown
                open={isOpenSlateViewsSelector}
                anchorEl={slateViewsSelectorAnchorEl}
                onClose={this.handleSlateViewsSelectorClose}
                listViews={listViews}
                mapViews={mapViews}
                onSlateViewClick={this.handleClickSlateView}
                onCreateViewClick={this.handleCreateViewDialogOpen}
              />
            )}

            <CreateViewDialog
              open={isOpenCreateViewDialog}
              onClose={this.handleCreateViewDialogClose}
            />
          </>
        ) : (
          <>
            <EmptyState
              icon="data_table"
              title={t('slateViews:noViewsTitle')}
              description={t('slateViews:noViewsDescription')}
              buttonLabel={t('slateViews:createView')}
              onAction={this.handleCreateViewDialogOpen}
            />
            <CreateViewDialog
              open={isOpenCreateViewDialog}
              onClose={this.handleCreateViewDialogClose}
            />
          </>
        )}
      </div>
    );
  }

  checkSlateViewType = (slateViewType) => {
    this.isListView = slateViewType === slateViewsTypes.LIST;
    this.isMapView = slateViewType === slateViewsTypes.MAP;
  };

  handleFetchSlates = (
    { sortDirection, sortColumnIndex, filters, currentSlateView, _accountUUID, fetchSlates },
    isNewSet = false,
    isChangedSlateView = false,
  ) => {
    const isSlatesAlreadyFetching = this.props.slatesGetEntity &&
      this.props.slatesGetEntity.isFetching;

    if( isSlatesAlreadyFetching ) {
      return;
    }

    let sort = '';
    if (sortDirection) {
      sort = `${sortColumnIndex},${sortDirection}`;
    }
    fetchSlates(currentSlateView.uuid, {
      isNewSet,
      filters,
      sort,
      isChangedSlateView,
      _accountUUID
    });
  };

  handleFetchView = async (currentAccountUuid, currentSlateViewUuid) => {
    this.setState({
      isViewListFakeLoading: true,
    });

   axios
    .get(`${api.GET_SLATE_VIEWS_LIST}/${currentAccountUuid}/views/${currentSlateViewUuid}/info`, options)
    .then((res) => {
      if (!this._isMounted) return;
      handleVersion(res);
      const views = res.data.data;

      // Guard: if the full view list has already been loaded by fetchSlateViewsList,
      // skip the single-view dispatch which would overwrite the full list.
      var listViews = this.props.listViews;
      var mapViews = this.props.mapViews;
      var hasFullList = (listViews && listViews.length > 1) || (mapViews && mapViews.length > 1);

      if (hasFullList) {
        // Full list already loaded -- just select the current view from it
        this.props.setCurrentSlateView(currentSlateViewUuid);
      } else {
        this.props.fetchSlateView({
          newSlateView: res.data.data,
        });
      }

      // Determine view type by checking which list contains this UUID
      var isMapType = mapViews && mapViews.some(function(v) { return v.uuid === currentSlateViewUuid; });
      this.checkSlateViewType(isMapType ? slateViewsTypes.MAP : slateViewsTypes.LIST);
      this.setState({
        isViewListFakeLoading: false,
      });
    });
  }

  handleAccountChanges = (nextProps) => {
    const { currentAccount, fetchSlateViewsList, currentUser } = this.props;

    if (nextProps.currentAccount) {
      if (
        currentAccount &&
        currentAccount.uuid !== nextProps.currentAccount.uuid
        && !isLoggedOut(currentUser)
      ) {
        fetchSlateViewsList(nextProps.currentAccount.uuid);
      }
      if (!currentAccount && !isLoggedOut(currentUser)) {
        fetchSlateViewsList(nextProps.currentAccount.uuid);
      }
    }
  };

  addAccountUuidToURL = (accountUuid) => {
    this.props.history.replace({
      pathname: `/accounts/${accountUuid}/views`,
    });
  };

  addSlateViewUUIDInURL = (currentSlateViewUuid, accountUuid) => {
    if (this.props.match.params.views !== currentSlateViewUuid) {
      this.props.history.replace({
        pathname: `/accounts/${accountUuid}/views/${currentSlateViewUuid}`,
      });
    }
  };

  checkSlateViewExist = () => {
    const { slateViewsListGetEntity, currentSlateView } = this.props;
    return !(
      slateViewsListGetEntity &&
      !slateViewsListGetEntity.isFetching &&
      !currentSlateView
    );
  };

  handleRefreshClick = () => {
    const {
      fetchSlateViewsList,
      currentAccount,
      currentUser,
      fetchCurrentSlate,
      slateInSlatePaneUUID,
    } = this.props;
    this.handleFetchSlates(this.props, true);

    if (!isLoggedOut(currentUser)) {
      fetchSlateViewsList(currentAccount.uuid);
    }

    if(slateInSlatePaneUUID) {
      fetchCurrentSlate(slateInSlatePaneUUID)
    }
  };

  // SCROLL HANDLING

  _handleScrollEvent = (e) => {
    let elem = e.target.classList;
    if (elem && elem.contains('body-grid') && this.active !== 'bodyGrid') {
      this.active = 'bodyGrid';
      e.target.focus();
    } else if (
      elem &&
      elem.contains('slate-pane-inner') &&
      this.active !== 'slatePane'
    ) {
      this.active = 'slatePane';
      e.target.focus();
    }
  };

  handleShareDialogOpen = () => {
    this.setState({ isOpenShareDialog: true });
  };

  handleShareDialogClose = () => {
    this.setState({ isOpenShareDialog: false });
  };


  handleExportDialogOpen = () => {
    this.setState({ isOpenExportDialog: true });
  };

  handleExportDialogClose = () => {
    this.setState({ isOpenExportDialog: false });
  };

  handleSlateViewsSelectorOpen = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.setState({
      isOpenSlateViewsSelector: true,
      slateViewsSelectorAnchorEl: e.currentTarget,
    });
  };

  handleSlateViewsSelectorClose = () => {
    this.setState({
      isOpenSlateViewsSelector: false,
      slateViewsSelectorAnchorEl: null,
    });
  };

  handleCreateViewDialogOpen = () => {
    this.setState({ isOpenCreateViewDialog: true });
  };

  handleCreateViewDialogClose = () => {
    this.setState({ isOpenCreateViewDialog: false });
  };

  handleClickSlateView = (uuid) => {
    checkVersion();
    const { currentSlateView, setCurrentSlateView } = this.props;
    const { accounts: accountUuid } = this.props.match.params;
    this.setState({ isOpenSlateViewsSelector: false });

    if (currentSlateView.uuid !== uuid) {
      setCurrentSlateView(uuid);
      this.addSlateViewUUIDInURL(uuid, accountUuid);
    }
  };

  showPreloader = () => {
    const {
      slateViewsListGetEntity,
      slatesGetEntity,
      createJobEntity,
      slates,
      currentSlateView,
    } = this.props;

    // slate views list is fetching
    if (slateViewsListGetEntity && slateViewsListGetEntity.isFetching) {
      return <Preloader />;
    }

    // SlateView isn't chosen in slateViewList
    if (!currentSlateView || !currentSlateView.name) {
      return <Preloader />;
    }

    // slates are fetching for the first time
    if (
      this.isListView &&
      !slates &&
      slatesGetEntity &&
      slatesGetEntity.isFetching
    ) {
      return <Preloader />;
    }

    // slates are fetching for map view
    if (this.isMapView && !this.isMapSlatesFetched && !this.isMapSlatesFetchFailed) {
      return <Preloader />;
    }

    // export slate view settings
    if (createJobEntity && createJobEntity.isFetching) {
      return <Preloader />;
    }
  };

  // SLATE PANE ACTIONS
  openSlatePane = (slateUUID) => {
    var slates = this.props.slates;
    var navList = slates ? slates.map(function(s) { return s.slateUUID; }) : [];
    var view = this.props.currentSlateView;
    var slateType =
      view && view.listViewType === listViewTypes.records
        ? slateTypes.record
        : slateTypes.slate;
    this.props.openSlateInPane(slateUUID, { navList: navList, slateType: slateType });
  };

  handleKeyDown = (
    e,
    navList,
    isPrevExist,
    isNextExist,
    prevSlateIndex,
    nextSlateIndex,
  ) => {
    switch (e.key) {
      case ARROW_UP: {
        if (isPrevExist) {
          if (e) {
            e.preventDefault();
          }
          this.delayedSlatePaneOpen(navList[prevSlateIndex]);
        }
        break;
      }
      case ARROW_DOWN: {
        if (isNextExist) {
          if (e) {
            e.preventDefault();
          }
          this.delayedSlatePaneOpen(navList[nextSlateIndex]);
        }
        break;
      }
      default:
        break;
    }
  };

  handleExportSlateView = () => {
    this.handleExportDialogClose();
    const { currentSlateView, createJob } = this.props;
    createJob(currentSlateView.uuid);
  };
}

const mapStateToProps = (state) => ({
  currentAccount: state.accounts.currentAccount,
  currentSlateView: state.slateViews.currentSlateView,
  slateViewType: state.slateViews.slateViewType,
  slates: state.slateViews.slates,
  autoRefresh: state.slateViews.autoRefresh,
  listViews: state.slateViews.listViews,
  mapViews: state.slateViews.mapViews,
  slatesToken: state.slateViews.slatesToken,
  filters: state.slateViews.filters,
  sortDirection: state.slateViews.sortDirection,
  sortColumnIndex: state.slateViews.sortColumnIndex,
  rowCount: state.slateViews.rowCount,
  slateViewsListGetEntity: state.entities[entityNames.GET_SLATE_VIEWS_LIST],
  slatesGetEntity: state.entities[entityNames.GET_SLATES],
  createJobEntity: state.entities[entityNames.CREATE_JOB],
  currentUser: state.currentUser,
  slateInSlatePaneUUID: state.slatePane.slateInSlatePaneUUID,
  slatePaneNavList: state.slatePane.slatePaneNavList,
  accountsList: state.accounts.accountsList,
});

const mapDispatchToProps = {
  fetchSlateViewsList,
  setCurrentSlateView,
  fetchSlates,
  fetchSlateView,
  clearSlates,
  openSlateInPane,
  updateSlatePane,
  createJob,
  showNotification,
  setCurrentAccountByUUID,
  getAccount,
  fetchCurrentSlate,
  getAccountByUUID,
};

// Unconnected class exported for unit tests
export { SlateView };

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(SlateView)),
);
